import { useContext } from "react";
import { AssistantSidebarContext } from "./AssistantSidebarContext";
const useAssistantSidebar = () => {
  const context = useContext(AssistantSidebarContext);
  if (!context) {
    throw new Error("useAssistantSidebar must be used within an AssistantSidebarContext");
  }
  return context;
};
export default useAssistantSidebar;
